import {
    GET_PATIENTS_REQUEST,
    GET_PATIENTS_SUCCESS,
    GET_PATIENTS_FAILURE,
    ADD_PATIENT_SUCCESS,
    ADD_PATIENT_REQUEST,
    ADD_PATIENT_FAILURE,
    DELETE_PATIENT_SUCCESS,
    DELETE_PATIENT_FAILURE
} from './constants';

const initialState = {
    loading: true,
    patientsList: [],
    loadingPatient:false,
    totalCount: undefined,
    patientAdded: undefined,
    patientDeleted: undefined,
};

const adminPatientsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PATIENTS_REQUEST: {
            return Object.assign({}, state, {loading: false, patientAdded: undefined, patientDeleted: undefined});
        }
        case GET_PATIENTS_SUCCESS: {
            return Object.assign({}, state, {loading: false, patientsList: action.data.patientsList, totalCount: action.data.totalCount, patientAdded: undefined, patientDeleted: undefined});
        }
        case GET_PATIENTS_FAILURE: {
            return Object.assign({}, state, {loading: false, patientsList: [], totalNumber: undefined, patientAdded: undefined, patientDeleted: undefined});
        }
        case ADD_PATIENT_REQUEST: {
            return Object.assign({}, state, {loading: false, patientAdded: undefined, patientDeleted: undefined, loadingPatient:true});
        }
        case ADD_PATIENT_SUCCESS: {
            return Object.assign({}, state, {loading: false, patientAdded: true, patientDeleted: undefined, loadingPatient:false});
        }
        case ADD_PATIENT_FAILURE: {
            return Object.assign({}, state, {loading: false, patientAdded: false, loadingPatient: false});
        }
        case DELETE_PATIENT_SUCCESS: {
            return Object.assign({}, state, {loading: false, patientsList: action.data.patientsList, totalCount: action.data.totalCount, patientAdded: undefined, patientDeleted: true});
        }
        case DELETE_PATIENT_FAILURE: {
            return Object.assign({}, state, {loading: false, patientAdded: undefined, patientDeleted: false});
        }
        default: {
            return state;
        }
    }
};

export default adminPatientsReducer;


// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/Patients/reducer.js